import type { SxProps, Theme } from '@mui/material/styles';

type ServiceDetailStyleMap = {
    loadingContainer: SxProps<Theme>
    root: SxProps<Theme>
    header: SxProps<Theme>
    card: SxProps<Theme>
    cardHeader: SxProps<Theme>
    infoRow: SxProps<Theme>
    statusRow: SxProps<Theme>
    statusValueWrap: SxProps<Theme>
    descriptionContent: SxProps<Theme>
    completedContent: SxProps<Theme>
    completedRow: SxProps<Theme>
    completedLabel: SxProps<Theme>
    tasksList: SxProps<Theme>
    taskItem: SxProps<Theme>
};

export const serviceDetailStyles: ServiceDetailStyleMap = {
    loadingContainer: { display: 'flex', justifyContent: 'center', mt: 8 },
    root: { display: 'flex', flexDirection: 'column', gap: 3 },
    header: { display: 'flex', alignItems: 'center', gap: 2 },
    card: { border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden' },
    cardHeader: { px: 3, py: 2, borderBottom: '1px solid', borderColor: 'divider' },
    infoRow: { px: 3, py: 2, display: 'grid', gridTemplateColumns: '160px 1fr', gap: 2 },
    statusRow: { px: 3, py: 2, display: 'grid', gridTemplateColumns: '160px 1fr', gap: 2, alignItems: 'center' },
    statusValueWrap: { display: 'flex', alignItems: 'center', gap: 1 },
    descriptionContent: { px: 3, py: 2.5 },
    completedContent: { px: 3, py: 3, display: 'flex', flexDirection: 'column', gap: 3 },
    completedRow: { display: 'flex', alignItems: 'center', gap: 2 },
    completedLabel: { minWidth: 160 },
    tasksList: { border: '1px solid', borderColor: 'divider', borderRadius: 1, overflow: 'hidden' },
    taskItem: { py: 0.75 },
};

export const serviceDetailIconColor = '#757575';
